import PropTypes from 'prop-types';

/**
 * A utility function to build a proper google maps url based on address data
 * @param {String} name
 * @param {String} streetName
 * @param {String} houseNumber
 * @param {String} postCode
 * @param {String} city
 * @returns {String}
 */
const buildMapsUrl = (name = '', streetName = '', houseNumber = '', postCode = '', city = '') =>
  `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
    `${name} ${streetName} ${houseNumber} ${postCode} ${city}`,
  )}`;

buildMapsUrl.propTypes = {
  name: PropTypes.string,
  streetName: PropTypes.string,
  houseNumber: PropTypes.string,
  postCode: PropTypes.string,
  city: PropTypes.string,
};

buildMapsUrl.defaultProps = {
  name: '',
  streetName: '',
  houseNumber: '',
  postcode: '',
  city: '',
};

export { buildMapsUrl }; // eslint-disable-line import/prefer-default-export
